import { createSlice, combineReducers } from '@reduxjs/toolkit';
import {
  fetchColunasDisponiveis,
  fetchColunasPreferencia,
  saveColunasPreferencia,
} from './actions';
import type { ColunaDisponivel } from '../types';

interface DisponiveisState {
  items: ColunaDisponivel[];
  escritorioId: string | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

const disponiveisInitialState: DisponiveisState = {
  items: [],
  escritorioId: null,
  loading: false,
  loaded: false,
  error: null,
};

const disponiveisSlice = createSlice({
  name: 'negociacaoColunasDisponiveis',
  initialState: disponiveisInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchColunasDisponiveis.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        if (state.escritorioId !== action.meta.arg) {
          state.items = [];
          state.loaded = false;
        }
      })
      .addCase(fetchColunasDisponiveis.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
        state.escritorioId = action.meta.arg;
        state.loaded = true;
      })
      .addCase(fetchColunasDisponiveis.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro ao carregar colunas';
      });
  },
});

interface PreferenciaState {
  fieldIds: string[];
  escritorioId: string | null;
  loading: boolean;
  loaded: boolean;
  saving: boolean;
  error: string | null;
}

const preferenciaInitialState: PreferenciaState = {
  fieldIds: [],
  escritorioId: null,
  loading: false,
  loaded: false,
  saving: false,
  error: null,
};

const preferenciaSlice = createSlice({
  name: 'negociacaoColunasPreferencia',
  initialState: preferenciaInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchColunasPreferencia.pending, (state, action) => {
        state.loading = true;
        state.error = null;
        if (state.escritorioId !== action.meta.arg) {
          state.fieldIds = [];
          state.loaded = false;
        }
      })
      .addCase(fetchColunasPreferencia.fulfilled, (state, action) => {
        state.loading = false;
        state.fieldIds = action.payload;
        state.escritorioId = action.meta.arg;
        state.loaded = true;
      })
      .addCase(fetchColunasPreferencia.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro ao carregar preferência';
      })
      .addCase(saveColunasPreferencia.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(saveColunasPreferencia.fulfilled, (state, action) => {
        state.saving = false;
        state.fieldIds = action.payload;
        state.loaded = true;
      })
      .addCase(saveColunasPreferencia.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload ?? 'Erro ao salvar preferência';
      });
  },
});

const negociacaoColunasReducer = combineReducers({
  disponiveis: disponiveisSlice.reducer,
  preferencia: preferenciaSlice.reducer,
});

export default negociacaoColunasReducer;
